import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from './constant';
export var routes = [{
  path: '/game/rank/:activityId',
  name: ROUTE_NAME.GAME_RANK,
  meta: {
    title: '百日竞技场',
    needBinding: true,
    needLoginNext: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "game" */
    './pages/rank.vue');
  }
}];